import { useState } from "react";
import { View } from "ui/atoms/view";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { EditIcon } from "ui/gluestack/icon";
import { Control, useWatch } from "react-hook-form";
import { FormControlledEditableText } from "ui/molecules/form/FormControlledEditableText";
import { AssessmentEditFormModel } from "../context/AssessmentEditContext";
import { Pressable } from "react-native";
import { useAssessmentEditPage } from "../context/AssessmentEditPageContext";

interface Props {
  control: Control<AssessmentEditFormModel>;
  index: number;
  placeholder?: string;
  className?: string;
  isDisabled?: boolean;
}

export function SectionHeaderMolecule({
  control,
  index,
  placeholder,
  className,
  isDisabled,
}: Props) {
  const { pageIndex } = useAssessmentEditPage();
  const sectionName = useWatch({
    control,
    name: `paginatedSections.${pageIndex}.sections.${index}.name`,
  });
  const [isEditing, setIsEditing] = useState(!sectionName);

  return (
    <View className={className}>
      <View className="flex-row items-center gap-2">
        <Pressable onPress={() => !isEditing && setIsEditing(true)}>
          <FormControlledEditableText
            control={control}
            name={`paginatedSections.${pageIndex}.sections.${index}.name`}
            id={`paginatedSections.${pageIndex}.sections.${index}.name`}
            placeholder={placeholder}
            isEditing={isEditing}
            autoFocus
            onSubmitEditing={() => setIsEditing(false)}
            onBlur={() => setIsEditing(false)}
            variant="large"
            fallbackText="Section Name"
            isRequired
            isDisabled={isDisabled}
          />
        </Pressable>
        {!isEditing && !isDisabled ? (
          <Button
            variant="link"
            size="xs"
            action="primary"
            onPress={() => setIsEditing((v) => !v)}
          >
            <ButtonIcon as={EditIcon} />
          </Button>
        ) : null}
      </View>
    </View>
  );
}
